import {createSlice, PayloadAction} from '@reduxjs/toolkit';

// @TODO уточнить типы
interface CacheEntry {
    data: any;
    timestamp: number;
    expiry?: number; // время жизни в миллисекундах
}

interface CacheState {
    [key: string]: CacheEntry;
}

const initialState: CacheState = {};

const CACHE_EXPIRY_TIME = 5 * 60 * 1000; // 5 минут по умолчанию

export const cacheSlice = createSlice({
    name: 'cache',
    initialState,
    reducers: {
        setCacheData: (
            state,
            action: PayloadAction<{
                key: string;
                data: any;
                expiry?: number;
            }>
        ) => {
            try {
                const { key, data, expiry = CACHE_EXPIRY_TIME } = action.payload;
                if (!key) {
                    console.warn('Cache key is empty');
                    return;
                }
                state[key] = {
                    data,
                    timestamp: Date.now(),
                    expiry,
                };
            } catch (e) {
                console.error('Error setting cache data:', e);
            }
        },
        clearCache: (state, action: PayloadAction<string | undefined>) => {
            try {
                if (action.payload) {
                    if (state[action.payload]) {
                        delete state[action.payload];
                    }
                } else {
                    // Очистка всего кэша
                    return initialState;
                }
            } catch (e) {
                console.error('Error clearing cache:', e);
            }
        },
        clearExpiredCache: (state) => {
            try {
                const now = Date.now();
                Object.keys(state).forEach((key) => {
                    try {
                        const entry = state[key];
                        if (!entry || !entry.timestamp) return;
                        const age = now - entry.timestamp;
                        if (entry.expiry && age > entry.expiry) {
                            delete state[key];
                        }
                    } catch (e) {
                        console.error(`Error clearing expired cache entry for key ${key}:`, e);
                    }
                });
            } catch (e) {
                console.error('Error in clearExpiredCache:', e);
            }
        },
    },
});

export const { setCacheData, clearCache, clearExpiredCache } = cacheSlice.actions;

// Селектор для получения данных из кэша с проверкой актуальности
export const selectCacheData = (state: { cache?: CacheState }, key: string): any | null => {
    try {
        if (!state?.cache || !key) {
            return null;
        }
        
        const entry = state.cache[key];
        if (!entry) {
            return null;
        }

        const now = Date.now();
        const age = now - (entry.timestamp || 0);

        // Проверка на истечение срока
        if (entry.expiry && age > entry.expiry) {
            return null;
        }

        return entry.data;
    } catch (e) {
        console.error('Error in selectCacheData:', e);
        return null;
    }
};

// Селектор для проверки наличия актуальных данных в кэше
export const selectIsCacheValid = (state: { cache?: CacheState }, key: string): boolean => {
    try {
        if (!state?.cache || !key) {
            return false;
        }
        
        const entry = state.cache[key];
        if (!entry) {
            return false;
        }

        const now = Date.now();
        const age = now - (entry.timestamp || 0);

        if (entry.expiry && age > entry.expiry) {
            return false;
        }

        return true;
    } catch (e) {
        console.error('Error in selectIsCacheValid:', e);
        return false;
    }
};

export default cacheSlice.reducer;
